import React from "react";
import ListOfApplicants from "./ListOfApplicants";

export default function JobInformation({ job, setJobStatusOpenPositions }) {
  return (
    <div className="">
      <div className="flex flex-col bg-white rounded-lg font-[Roboto] p-4 space-y-3">
        <span
          className="cursor-pointer mb-4"
          onClick={() => {
            setJobStatusOpenPositions(false);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
        </span>
        <span className="flex flex-row justify-between">
          <span className="flex flex-row items-center text-gray-700">
            <span className="mr-8">Title:</span>
            <span className="text-sm">{job.title}</span>
          </span>
          <span
            className="px-2 py-1 rounded-md text-sm"
            style={{
              backgroundColor:
                job.status === "Open"
                  ? "rgba(246, 104, 104, 0.2)"
                  : "rgba(229, 197, 28, 0.2)",
              color: job.status === "Open" ? "#F66868" : "#E5C51C",
            }}
          >
            {job.status}
          </span>
        </span>
        <span className="flex flex-row items-center text-gray-700">
          <span className="mr-8">Description:</span>
          <span className="text-justify text-sm">{job.description}</span>
        </span>
        <span className="flex flex-row items-center text-gray-700">
          <span className="mr-8">Skills:</span>
          <span className="space-x-3">
            {job.skills.map((theJob) => {
              return (
                <span
                  style={{
                    width: "83px",
                    height: "25px",
                    color: "#139588",
                    border: "1px solid #139588",
                  }}
                  className="text-justify text-sm py-0.5 px-1"
                >
                  {theJob}
                </span>
              );
            })}
          </span>
        </span>
        <span className="flex justify-between">
          <span> City : {job.city}</span>
          <span> Start Date : {job.startDate}</span>
          <span> Hourly Rate : {job.hourlyRate}</span>
        </span>
      </div>
      <div className="mt-4">
        <ListOfApplicants />
      </div>
    </div>
  );
}
